import styled, { css } from 'styled-components';
import { Media } from 'enums';
import { Icon, Input, Text } from 'view/atoms';
import { PADDING_DIFF_FOR_SCROLL } from 'styles/customScroll';

export const SearchBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-self: center;
  position: relative;
  margin-right: 20px;
  flex: 1;

  @media ${Media.tablet} {
    width: 340px;
  }
  @media ${Media.notebook} {
    width: auto;
    margin-right: 0;
  }
`;

export const SearchInput = styled(Input)<{ active: boolean }>`
  border: transparent;
  background-color: ${({ theme }) => theme.colors.background};
  padding-right: 45px;

  @media ${Media.tablet} {
    padding-right: 50px;
  }

  @media ${Media.notebook} {
    padding-right: 63px;
  }

  @media ${Media.desktop} {
    padding-right: 24px;
  }

  :focus {
    background-color: ${({ theme }) => theme.colors.white};
  }

  ${({ active }) =>
    active &&
    css`
      display: block;
      width: 100%;
      align-self: stretch;
    `};
`;

export const AnswerModal = styled.div`
  position: absolute;
  top: 65px;
  width: 340px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 15px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 20px;
  padding-right: ${20 - PADDING_DIFF_FOR_SCROLL}px;
  padding-bottom: 0px;
  display: none;

  @media ${Media.notebook} {
    display: block;
    width: 470px;
    min-height: 102px;
  }

  @media ${Media.desktop} {
    width: 500px;
  }
`;

export const AnswerContent = styled.div`
  margin: 20px 0 0 0;

  @media ${Media.notebook} {
    margin: 0;
    min-height: 62px;
  }
`;

export const TextTitleContent = styled(Text)`
  line-height: 130%;
`;

export const TextTitle = styled(Text)`
  &:first-child {
    margin: 0 0 14px 0;
    line-height: 128%;
  }
`;

export const TextDescription = styled(TextTitle)`
  line-height: 130%;
`;

export const IconSearch = styled(Icon)<{ isSingle?: boolean }>`
  cursor: ${({ isSingle }) => (isSingle ? 'pointer' : 'default')};
`;
